import React from 'react';

import { Grid, Typography, Checkbox, FormControlLabel } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import SquareIcon from '@mui/icons-material/Square';
import HeaderSkeleton from './HeaderSkeleton';
import HeaderNoData from './HeaderNoData';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2)
  },
  heading: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: theme.spacing(2.6)
  },
  legendText: {
    color: theme.palette.text.secondary
  },
  legendIcon: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(0.4)
  },
  legendIconSkeleton: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(0.4),
    color: theme.palette.grey[300]
  },
  legendBox: {
    paddingLeft: theme.spacing(2)
  },
  skeletonBox: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    alignItems: 'center'
  },
  checkBox: {
    color: theme.palette.common.black,
    marginLeft: theme.spacing(3)
  },
  label: {
    '&.MuiFormControlLabel-root': {
      ...theme.typography.caption
    }
  }
}));

type HeaderProp = {
  currentData: any[];
  headerNameComponent: JSX.Element;
  checked: boolean;
  handleCheckBoxChange: (event: any) => void;
  disabled: boolean;
  loading: boolean;
  isEmpty: boolean;
};

const Header: React.FC<HeaderProp> = ({
  currentData,
  headerNameComponent,
  checked,
  handleCheckBoxChange,
  disabled,
  loading,
  isEmpty
}: HeaderProp) => {
  const classes = useStyles();

  return (
    <Grid item container className={classes.container}>
      <Grid item xs={5.5} container alignItems={'center'}>
        {headerNameComponent}
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              className={classes.checkBox}
              checked={checked}
              onChange={handleCheckBoxChange}
              disabled={disabled}
            />
          }
          disableTypography={true}
          label={
            <Typography variant="caption" className={classes.legendText}>
              <FormattedMessage id="insights.timeUtilizationChart.hideDaysLabel" />
            </Typography>
          }
          className={classes.label}
        />
      </Grid>
      <Grid container item xs={6.5} justifyContent={'flex-end'}>
        {loading ? (
          <HeaderSkeleton />
        ) : isEmpty ? (
          <HeaderNoData />
        ) : (
          currentData.map((x) => (
            <Grid key={x.name} item className={classes.legendBox}>
              <SquareIcon
                fontSize="small"
                sx={{ color: x.color }}
                className={classes.legendIcon}
              />
              <Typography variant="caption" className={classes.legendText}>
                {x.name}
              </Typography>
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
};
export default React.memo(Header);
